import {IconButton} from '@dropbox/dig-components/buttons';
import {Stack} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {AddLine} from '@dropbox/dig-icons/assets';
import {pulseUserAtom} from 'atoms/auth';
import {AddBadgeModal} from 'components/badges/AddBadgeModal';
import {LoadedManageBadgesList, ManageBadgesList} from 'components/badges/ManageBadgeList';
import {Layout} from 'components/DSYS/Layout';
import {Title} from 'components/DSYS/Title';
import {ROUTE_PATHS} from 'constant';
import {isSuperUser} from 'helpers/utils';
import {useDocumentTitle} from 'hooks/useDocumentTitle';
import {useAtomValue} from 'jotai';
import {Suspense, useState} from 'react';
import {queryClient} from 'views/QueryClientWrapper';

export const ManageBadgesView = () => {
  const [addingBadge, setAddingBadge] = useState(false);
  const pulseUser = useAtomValue(pulseUserAtom);
  useDocumentTitle('Badges');

  return (
    <>
      <Layout.Container
        breadcrumb={[
          {children: 'Admin', to: ROUTE_PATHS.ADMIN},
          {children: 'Badges', to: ROUTE_PATHS.ADMIN_MANAGE_BADGES},
        ]}
      >
        <Stack gap="24">
          <Title
            size={24}
            withAccessoryEnd={
              pulseUser && isSuperUser(pulseUser) ? (
                <IconButton
                  aria-label="Add badge"
                  onClick={() => setAddingBadge(true)}
                  variant="opacity"
                  shape="circular"
                >
                  <UIIcon src={AddLine} />
                </IconButton>
              ) : undefined
            }
          >
            Badges
          </Title>

          <Suspense fallback={<ManageBadgesList />}>
            <LoadedManageBadgesList />
          </Suspense>
        </Stack>
      </Layout.Container>
      <AddBadgeModal
        open={addingBadge}
        onClose={() => {
          queryClient.invalidateQueries({queryKey: ['ownedBadges']});
          setAddingBadge(false);
        }}
      />
    </>
  );
};
